
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Automation","transform":"translate(-684.923 -628)"}},[_c('g',{attrs:{"id":"Group_23818","data-name":"Group 23818","transform":"translate(0 18)"}},[_c('path',{attrs:{"id":"Path_20071","data-name":"Path 20071","d":"M11.315 5.683a1.912 1.912 0 00-.564-1.357 1.968 1.968 0 00-2.717 0L.593 11.768a1.921 1.921 0 002.715 2.716l7.442-7.442a1.91 1.91 0 00.564-1.359zM2.421 13.6a.682.682 0 01-.941 0 .666.666 0 010-.941l4.872-4.873.948.944zm7.444-7.445L8.18 7.841 7.239 6.9l1.686-1.688a.667.667 0 11.941.941zM3.078 1.79l.972-.277.277-.972a.747.747 0 011.436 0l.277.972.972.277a.747.747 0 010 1.436L6.04 3.5l-.277.972a.747.747 0 01-1.436 0L4.05 3.5l-.972-.277a.747.747 0 010-1.436zm11.458 8.96l-.972.277-.277.973a.747.747 0 01-1.436 0l-.277-.972-.974-.278a.747.747 0 010-1.436l.972-.277.277-.972a.747.747 0 011.436 0l.277.972.972.277a.747.747 0 010 1.436zm-3.375-9.183l.85-.243.244-.851a.653.653 0 011.254 0l.243.85.85.243a.653.653 0 010 1.254l-.85.243-.243.852a.653.653 0 01-1.254 0l-.243-.85-.851-.244a.653.653 0 010-1.254z","transform":"translate(684.847 610)","fill":"#777a8d"}})])])])
          )
        }
      }
    